import React from "react";
import {  Modal } from "react-bootstrap";
import {   StyledBlueButton  } from "../../styles/BootstrapStyles";
import "../../styles/form.scss";

const PopupModal=({show,message,title,onClose})=>{
    return (
        <Modal
          className="modal warning-modal"
          show={show }
          dialogClassName="modalDialog"
        >
          <Modal.Header className="modalHeader">
            <Modal.Title className="modalHeaderTitle">{title}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="modalBody py-4">
            {message}
          </Modal.Body>
          <Modal.Footer>
            <StyledBlueButton
              onClick={onClose}>
              OK
            </StyledBlueButton>
          </Modal.Footer>
        </Modal>
    )
}

PopupModal.defaultProps={
    show:false,
    title:'',
    message:'',
    onClose:()=>{/*We are sending onClose function as a default Prop*/}
}

export default PopupModal;